import { ControlStateOptions } from "./ControlStateOptions"

/**
 *  Determine CSS classes for placeholder elements. These classes will specifically
 *  target placeholder pseudo-element.
 */
export function determinePlaceholderTextClasses(_: ControlStateOptions) {
  return "placeholder:text-gray-400 placeholder:text-body2/regular"
}
